import { getGlobalHeadersAsObject } from "./global-headers";

const URL = "/api/v2/banner-snooze/";

/** Banners this user has muted until tomorrow morning. A key is the banner's
 * kind, optionally followed by `:` and the state it reported when muted. */
export interface BannerSnoozes {
	snoozed: string[];
}

export const fetchBannerSnoozes = async (): Promise<BannerSnoozes> => {
	const response = await fetch(URL, { headers: { ...getGlobalHeadersAsObject() } });
	if (!response.ok) {
		throw new Error(`Failed to fetch ${URL}: ${response.statusText}`);
	}
	return response.json();
};

export const snoozeBanner = async (bannerKey: string): Promise<void> => {
	const response = await fetch(URL, {
		method: "POST",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ banner_key: bannerKey }),
	});
	if (!response.ok) {
		throw new Error(`Failed to snooze ${bannerKey}: ${response.statusText}`);
	}
};
